module.exports = __webpack_public_path__ + "img/GPB-1-500x500.0b067baf.png";